export type ConsentState = "accepted" | "declined" | "unknown";

const KEY = "alvion.consent";

export function getConsent(): ConsentState {
  if (typeof window === "undefined") return "unknown";
  const v = localStorage.getItem(KEY);
  if (v === "accepted" || v === "declined") return v;
  return "unknown";
}

export function setConsent(state: Exclude<ConsentState, "unknown">) {
  localStorage.setItem(KEY, state);
  window.dispatchEvent(new CustomEvent("alvion:consent", { detail: state }));
}

export function onConsentChange(cb: (s: ConsentState) => void) {
  const h = (e: Event) => cb((e as CustomEvent).detail as ConsentState);
  window.addEventListener("alvion:consent", h);
  return () => window.removeEventListener("alvion:consent", h);
}
